module.exports = __webpack_public_path__ + "img/icon_2.83ba2faf.svg";